"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = logout;
var urls_1 = require("./urls");
var utils_1 = require("./utils");
var configuration_1 = require("./configuration");
var axios_1 = __importDefault(require("axios"));
function revokeAccessToken() {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = (0, utils_1.getAccessToken)();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: "post",
                            url: "".concat(configuration_1.configuration.businessAppAuthenticationApi.host, "/v1/oauth/revoke"),
                            data: {
                                accessToken: accessToken,
                            },
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json;charset=UTF-8",
                            },
                            withCredentials: true,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    (0, utils_1.expireAccessToken)();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function logout(config, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.analytics) {
                        window.analytics.reset();
                    }
                    if (window.amplitude) {
                        window.amplitude.regenerateDeviceId();
                        window.amplitude.setUserId(null);
                    }
                    if (config) {
                        (0, configuration_1.setConfiguration)(config);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, revokeAccessToken()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3: 
                /**
                 * Instead of returning while the side-effecty redirect is happening, return a suspended promise (one that never resolves or rejects).
                 * That will keep the user of the login function hanging until the browser has redirected.
                 * This solves an issue where the app started rendering when the user wasn't actually logged in, throwing all kinds of errors from api calls made without auth.
                 */
                return [2 /*return*/, new Promise(function () {
                        window.location.href = (0, urls_1.getAuthenticateUrl)(window.location.href, options);
                    })];
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=logout.js.map